export const SITE_URL = 'https://этороссия.shop';
export const SITE_NAME = 'ЭТО РОССИЯ';
export const DEFAULT_TITLE = 'ЭТО РОССИЯ — патриотическая одежда и мерч | Официальный магазин';
export const DEFAULT_DESCRIPTION =
    'ЭТО РОССИЯ — бренд патриотической одежды. Футболки, мерч и коллекции, вдохновлённые историей и культурой России. Доставка по всей стране.';

export const DEFAULT_OG_IMAGE = 'https://этороссия.shop/og-image.png';
